import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/river2/pc/');
export default function O() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2.river2.details');
    const { locale } = useRouter();

    // 暂定最多是4条, 根据站点截取
    const descCards = [
        {
            desc: t('sec15_item_1_desc'),
            title: t('sec15_item_1_title'),
        },
        {
            desc: t('sec15_item_2_desc'),
            title: t('sec15_item_2_title'),
        },
        {
            desc: t('sec15_item_3_desc'),
            title: t('sec15_item_3_title'),
        },
        {
            desc: t('sec15_item_4_desc'),
            title: t('sec15_item_4_title'),
        },
    ];

    const getCardContent = () => {
        switch (locale) {
            case 'us':
            case 'ca':
            case 'za':
            case 'jp':
            case 'es':
            case 'it':
                return descCards.splice(0, 2);
            case 'uk':
            case 'eu':
            case 'de':
            case 'fr':
            case 'cn':
            case 'ph':
                return descCards.splice(0, 3);
            default:
                return descCards.splice(0, 2);
        }
    };

    return (
        <div className={`${css.O_15} river2_detials_O`}>
            <div className={`sticky-wrapper`}>
                <div className="text-wrapper">
                    {/* <div className="upper-title">{t('river2.details.sec6_upper_title')}</div> */}
                    <div className="title">{t('sec15_title')}</div>
                    <div className="desc">
                        {t.rich('sec15_subtitle', {
                            p1: (child: any) => <span className="white">{child}</span>,
                        })}
                    </div>
                </div>
                <div className="img-wrapper-swiper">
                    <Swiper
                        className="cards h5"
                        modules={[Scrollbar, Navigation]}
                        spaceBetween={20}
                        // centeredSlides={true}
                        navigation={true}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 90,
                            snapOnRelease: true,
                        }}
                    >
                        {getCardContent()?.map((card: any, k: number) => (
                            <SwiperSlide className={`card item-${k + 1}`} key={k}>
                                <div className="card-content">
                                    <p className="card-desc desc">
                                        <span className={`comma left-comma left-comma-${k + 1}`}>“</span>
                                        {card.desc}
                                        <span className="comma right-comma">”</span>
                                    </p>
                                </div>
                                <p className="card-title">{card?.title}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
